const store = {
    namespaced: true,
    state() {
        return {
            list: [],
            products: [],
            recommended: [],
            price: 0,
            tax: 0,
            deliveryPrice: 0,
            weight: 0,
            bonuses: 0,
            available_bonuses: 0,
            used_bonuses: 0,
            discount: 0,
            total: 0,
            promocode: null,
            promocodeData: null
        };
    },
    getters: {
        counter(state) {
            return state.list.reduce((accumulator, current) => accumulator + current.qtt, 0);
        }
    },
    mutations: {
        setList(state, data) {
            state.list = data;
            this.$cookies.set('cart', state.list, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365
            });
        },
        setProducts(state, data) {
            state.products = data;
        },
        setRecommended(state, data) {
            state.recommended = data;
        },
        setPrice(state, data) {
            state.price = data;
        },
        setTax(state, data) {
            state.tax = data;
        },
        setDeliveryPrice(state, data) {
            state.deliveryPrice = data;
        },
        setBonuses(state, data) {
            state.bonuses = data;
        },
        setAvailableBonuses(state, data) {
            state.available_bonuses = data;
        },
        setUsedBonuses(state, data) {
            state.used_bonuses = data;
        },
        setDiscount(state, data) {
            state.discount = data;
        },
        setTotal(state, data) {
            state.total = data;
        },
        setPromocode(state, data) {
            state.promocode = data;
        },
        setPromocodeData(state, data) {
            state.promocodeData = data;
        },
        reset(state) {
            state.list = [];
            state.products = [];
            state.price = 0;
            state.bonuses = 0;
            state.discount = 0;
            state.total = 0;
            this.$cookies.remove('cart');
        },
        addItem(state, goods) {
            state.list = this.$cookies.get('cart') || [];

            const currentItem = state.list.find(item => {
                return item.id === goods.id && item.grindingMethodId === goods.grindingMethodId;
            });

            if (currentItem) {
                currentItem.qtt++;
            } else {
                state.list.push(goods);
            }

            this.$cookies.set('cart', state.list, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365
            });
        },
        removeItem(state, goods) {
            state.list = this.$cookies.get('cart') || [];

            let index = 0;
            const currentItem = state.list.find((item, i) => {
                if (item.id === goods.id && item.grindingMethodId === goods.grindingMethodId) {
                    index = i;
                    return item;
                }
            });

            if (currentItem) {
                if (currentItem.qtt > 1) {
                    currentItem.qtt--;
                } else {
                    state.list.splice(index, 1);
                }
            }

            this.$cookies.set('cart', state.list, {
                path: '/',
                maxAge: 60 * 60 * 24 * 365
            });
        },
        calculate(state) {
            let weight = 0;

            state.products.forEach(item => {
                if (item.weight_gr) {
                    weight += item.weight_gr * item.qtt;
                }
            });

            state.total = state.total - state.used_bonuses;
            state.weight = weight;
        }
    },
    actions: {
        getProducts({ state, commit, rootState }) {
            if (!this.$cookies.get('cart')) return;

            const cartData = this.$cookies.get('cart');
            const productIds = cartData?.length ? cartData.map(item => item.id) : [];

            // if (this.$config.country === 'pl') {
            //     if (rootState.order.settlement) {
            //         params.settlement_external_id = rootState.order.settlement.external_id;
            //     }
            //     if (rootState.order.deliveryType) {
            //         params.delivery_type_id = rootState.order.deliveryType.id;
            //     }
            // }

            return this.$axios
                .get('/general/product-filter', { params: { ids: productIds?.join(',') } })
                .then(response => {
                    const data = response.data;
                    // const formattedData = data.map(product => ({
                    //     ...product,
                    //     qtt: cartData.find(item => item.id === product.productId)?.qtt || 0
                    // }));

                    // Строим массив непосредственно на основе cartData
                    const cartList = cartData.map(cartItem => {
                        // Для каждого элемента в корзине ищем соответствующий продукт
                        const product = data.find(p => p.productId === cartItem.id);

                        // Встраиваем нужные данные
                        return {
                            ...product,
                            qtt: cartItem.qtt,
                            grindingMethodId: cartItem.grindingMethodId
                        };
                    });
                    // console.log(data, cartData, 'cartcart', cartList);
                    const totalPrice = arr => arr.reduce((sum, item) => sum + parseFloat(item.price) * item.qtt, 0);
                    const discount = state?.promocodeData?.discount_sum || '0';
                    commit('setProducts', cartList);
                    commit('setDiscount', parseFloat(discount));
                    commit('setTotal', totalPrice(cartList) - parseFloat(discount));
                    // commit('setPrice', data.price);
                    // if (this.$config.country === 'pl') {
                    //     commit('setTax', data.tax);
                    //     commit('setDeliveryPrice', data.delivery_price);
                    // }
                    // commit('setBonuses', Math.floor(data.bonuses));
                    // commit('setAvailableBonuses', Math.floor(data.available_bonuses));
                    // commit('setDiscount', data.discount);
                    // commit('setTotal', data.total);
                    // commit('setPromocodeData', data.promocode);

                    // const list = data.goods.map(product => ({
                    //     goodscardId: product.goodscard_id,
                    //     grindingMethodId: product.grindingMethod ? product.grindingMethod.id : null,
                    //     id: product.id,
                    //     qtt: product.qtt
                    // }));

                    // if (JSON.stringify(state.list) !== JSON.stringify(list)) {
                    //     commit('setList', list);
                    // }

                    // commit('calculate');

                    return data;
                })
                .catch(error => {
                    commit('reset');
                    throw error;
                });
        },
        getRecommended({ state, commit }) {
            if (!state.list || !state.list[0]) return;

            const ids = state.list.map(item => item.id);

            return this.$axios
                .get('/api/v1/recommended', {
                    params: { id: ids }
                })
                .then(response => {
                    commit('setRecommended', response.data);
                    return response;
                })
                .catch(error => {
                    commit('reset');
                    throw error;
                });
        },
        addProduct({ commit }, product) {
            commit('addItem', product);
            commit('calculate');
        },
        removeProduct({ commit }, product) {
            commit('removeItem', product);
            commit('calculate');
        }
    }
};

export default store;
